module.exports = __webpack_public_path__ + "img/mz.a8dad12f.svg";